import { render } from "./Ortho3dBottomBar.vue?vue&type=template&id=4cf5f60e&scoped=true"
import script from "./Ortho3dBottomBar.vue?vue&type=script&lang=js"
export * from "./Ortho3dBottomBar.vue?vue&type=script&lang=js"

import "./Ortho3dBottomBar.vue?vue&type=style&index=0&id=4cf5f60e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf5f60e"]])

export default __exports__